import { ActionSanitizer } from 'store/devToolsActionSantizer';
import { AnyAction } from 'store/store';
import { PortfolioSummaryAggregatedData } from './PortfolioSummaryDataState';
import {
    PortfolioSummaryDataActionType,
    PortfolioSummarySetAggregatedDataAction,
} from './actions';

export const portfolioSummarySetAggregatedDataActionSanitizer: ActionSanitizer =
    <A extends AnyAction>(action: A) => {
        if (
            action.type !==
            PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA
        ) {
            return action;
        }

        const setAggregaredDataAction =
            action as unknown as PortfolioSummarySetAggregatedDataAction;

        const sanitized = {
            type:
                PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA +
                '_SANITIZED',
            payload: {
                aggregationField:
                    setAggregaredDataAction.payload?.aggregationField,
                data: sanitiseAggregatedData(
                    setAggregaredDataAction.payload!.data
                ),
            },
        } as unknown as A;

        return sanitized;
    };

export function sanitiseAggregatedData(
    aggregatedData: PortfolioSummaryAggregatedData
): string {
    return `groups: ${Object.keys(aggregatedData).length}`;
}
